// Public routes
import Dev from '../pages/Dev';
import Home from '../pages/Home';
import Login from '../pages/Login';
import CheckBalance from '../pages/CheckBalance';
import MyTransactions from '../pages/MyTransactions';
import ForgotPassword from '../pages/ForgotPassword';
import ResetPassword from '../pages/ResetPassword';
import Transaction from '../pages/NewTransaction';
import UserPoints from '../pages/UserPoints';

export const publicRoutes = [
  {
    key: 'login',
    path: '/login',
    component: Login,
    exact: true,
  },
  {
    key: 'forgot-password',
    path: '/forgot-password/:token',
    component: ForgotPassword,
    exact: true,
  },
  {
    key: 'reset-password',
    path: '/reset-password',
    component: ResetPassword,
    exact: true,
  },
];

export default [
  {
    exact: true,
    title: 'Início',
    iconClass: 'fas fa-home',
    path: '/',
    component: Home,
    hidden: true,
  },
  {
    path: '/dev',
    title: 'Dev',
    component: Dev,
    hidden: true,
  },
  {
    title: 'NOVA TRANSAÇÃO',
    path: '/nova-transacao',
    component: Transaction,
  },
  {
    title: 'Ranking de pontos',
    path: '/ranking-de-pontos',
    component: UserPoints,
  },
  {
    title: 'Minhas Transações',
    path: '/minhas-transacoes',
    component: MyTransactions,
  },
  {
    title: 'Consultar Saldo',
    path: '/consultar-saldo',
    component: CheckBalance,
  },
];
